(() => {
  const CONFIG = {
    productHandle: "loda-performance-socks",
    defaultVariantId: "54596704076044"
  };

  const hasVariantParam = () => new URLSearchParams(location.search).has("variant");

  const currentHandle =
    document.body.getAttribute("data-product-handle") ||
    document.documentElement.getAttribute("data-product-handle");

  function redirectToDefaultVariant() {
    if (!currentHandle) return;
    if (currentHandle !== CONFIG.productHandle) return;
    if (hasVariantParam()) return;

    const url = new URL(location.href);
    url.searchParams.set("variant", CONFIG.defaultVariantId);

    location.replace(url.toString());
  }

  document.addEventListener("DOMContentLoaded", redirectToDefaultVariant);
})();